import { FilterProps } from "../filter-definition";
import { DateRangeFilter } from "../GenericFilters";

export const StartShipFilter = ({ variant }: FilterProps) => (
  <DateRangeFilter filterKey="startShip" name="Start Ship" variant={variant} />
);
